import {
  isDocRef,
  isObject,
  isWithRef,
  WithRef,
} from '@principle-theorem/shared';
import { DocumentReference } from 'firebase-admin/firestore';
import { isString } from 'lodash';
import { ICustomFormConfiguration } from '../custom-forms/custom-form-config';
import { PatientFormSpecialUid } from '../patient/patient';
import {
  IAutomation,
  IAutomationConfiguration,
  IAutomationResource,
  isAutomation,
  isAutomationConfiguration,
} from './automation';

export interface IAutomatedFormIssue extends IAutomationResource {
  name: string;
  formConfigurationRef?: DocumentReference<ICustomFormConfiguration>;
  specialForm?: PatientFormSpecialUid;
}

export function isAutomatedFormIssue(
  data: unknown
): data is IAutomatedFormIssue {
  return (
    isObject(data) &&
    isString(data.name) &&
    (isDocRef(data.formConfigurationRef) || isString(data.specialForm))
  );
}

export interface IAutomatedFormIssueConfiguration
  extends IAutomationConfiguration,
    IAutomatedFormIssue {}

export function isAutomatedFormIssueConfiguration(
  data: unknown
): data is IAutomatedFormIssueConfiguration {
  return isAutomatedFormIssue(data) && isAutomationConfiguration(data);
}

export function isFormIssueAutomation(
  automation: unknown
): automation is WithRef<IAutomation<IAutomatedFormIssue>> {
  return (
    isWithRef(automation) &&
    isAutomation<IAutomatedFormIssue>(automation, isAutomatedFormIssue)
  );
}
